import { createFileRoute } from "@tanstack/react-router"

import BudgetTab from "~/components/demand-2/tabs/BudgetTab"

export const Route = createFileRoute("/_auth/demand/fashion/$collectionId/_layout/budget")({
  component: RouteComponent,
})

function RouteComponent() {
  return <BudgetTab kind="fashion" />
}
